import { render } from "./FolderSidebar.vue?vue&type=template&id=b84eda2e&scoped=true"
import script from "./FolderSidebar.vue?vue&type=script&lang=js"
export * from "./FolderSidebar.vue?vue&type=script&lang=js"

import "./FolderSidebar.vue?vue&type=style&index=0&id=b84eda2e&scoped=true&lang=css"
import "./FolderSidebar.vue?vue&type=style&index=1&id=b84eda2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84eda2e"]])

export default __exports__